export const demoTotals = {
  all: 195,
  'public/blog/posts': 58,
  'public/site/pages': 73,
  'public/stores/products': 64,
};

export const listLayoutBreakPoint = 520;
